import { TransitionGroup } from "react-transition-group";
import styled from "astroturf";

export const MainTransitionGroup = styled(TransitionGroup)`
  width: 100%;
  height: 100%;
`;
